import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { OrganizationService } from '../organization.service';
import { AuthService } from 'src/app/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.css'],
    standalone: false
})
export class UserProfileComponent implements OnInit{


  public userdata: any;
 
  userTypes = [
    /*{ id: 1, label: 'Super Admin' },*/
    { id: 2, label: 'Admin' },
    { id: 3, label: 'Analyst' },
    { id: 4, label: 'Operator' }
  ];


  statusOptions = [
    { value: 1, label: 'Active' },
    { value: 0, label: 'In-Active' }
  ];

  phonePattern = '^((\\+\\d{1,3}[- ]?)?\\(?\\d{1,4}\\)?[- ]?\\d{1,4}[- ]?\\d{1,4}[- ]?\\d{1,4}|\\(?\\d{3}\\)?[- ]?\\d{3}[- ]?\\d{3})$';
  filteredOrganizations = [];
  displayedColumns: string[] = ['organization', 'role', 'status'];
  
  constructor(
    
    private userService: UserService,
    private authService: AuthService,
    private organizationService: OrganizationService,
    private cdRef: ChangeDetectorRef,
    private snackBar: MatSnackBar
  
  ) {
    
   
  }
   async ngOnInit(): Promise<void> {
    //this.loadOrganizations();
    // Optionally trigger change detection here if necessary
    this.getUserProfile();
    this.cdRef.detectChanges();
  }
 
  async getUserProfile(): Promise<void> {
    const user = this.authService.getUserDetails();
    this.userdata = await this.userService.getUserById(user.userId);
    console.log("userdata===", this.userdata.organization)
  }
 
 async updateUserProfile() {
    try {
      // Await the updateUser service call
      await this.userService.updateUser(this.userdata);

      this.authService.updateUserDetails(this.userdata); // Update localStorage + notify subscribers
  // Assuming you get updatedUser object from form or API
     
      // Show success message after successful update
      this.snackBar.open('User successfully updated', 'Close', {
        duration: 3000, // Duration in milliseconds
      });
    } catch (error) {
      // Show error message if update fails
      this.snackBar.open('Failed to update user', 'Close', {
        duration: 3000, // Duration in milliseconds
      });
    }
  }



  
  getRole(userType: number): string {
    switch (userType) {
        case 1:
            return 'Super Admin';
        case 2:
            return 'Admin';
        case 3:
            return 'Analyst';
         case 4:
              return 'Operator';
            
        default:
            return 'Analyst'; // Fallback in case of unexpected userType
    }
}
getStatus(status: number): string {
  switch (status) {
      case 1:
          return 'Active';
      case 0:
          return 'In-Active';
    
      default:
          return 'Active'; 
  }
}
}
